import { EntranceDirectionEnum } from '../__generated__/graphql';

const DirectionArrowSVG = ({
  direction,
  isActive,
}: {
  direction: EntranceDirectionEnum;
  isActive: boolean;
}) => {
  const rotationMap: Record<EntranceDirectionEnum, string> = {
    [EntranceDirectionEnum.Left]: 'rotate(-90deg)',
    [EntranceDirectionEnum.Top]: 'rotate(0deg)',
    [EntranceDirectionEnum.Bottom]: 'rotate(180deg)',
    [EntranceDirectionEnum.Right]: 'rotate(90deg)',
  };

  const arrowColor = isActive ? 'var(--color-white)' : 'var(--color-primary)';

  return (
    <svg
      width="12"
      height="28"
      viewBox="0 0 29 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: rotationMap[direction],
        transition: 'transform 0.3s ease',
        fill: arrowColor,
      }}
    >
      <path d="M26.3697 22.1154L14.7966 10.7859C14.5171 10.4495 14.0179 10.4033 13.6815 10.6827C13.6441 10.7138 13.6095 10.7483 13.5783 10.7859L2.00525 22.1154C1.6352 22.4584 1.61328 23.0366 1.95628 23.4066C2.12638 23.5901 2.36422 23.6959 2.61442 23.6991H8.09638L8.09638 38.3787C8.20037 38.9922 8.69657 39.4636 9.3146 39.5361L19.0604 39.5361C19.5478 39.5361 19.6695 38.927 19.6695 38.3787L19.6695 23.6991H25.7606C26.2652 23.6925 26.6688 23.2781 26.6622 22.7735C26.6589 22.5233 26.5532 22.2855 26.3697 22.1154Z" />
      <path d="M19.0603 41.3634L9.31449 41.3634C8.80989 41.3634 8.40079 41.7725 8.40079 42.2771C8.40079 42.7816 8.80989 43.1908 9.31449 43.1908L19.0603 43.1908C19.5649 43.1908 19.974 42.7816 19.974 42.2771C19.974 41.7725 19.565 41.3634 19.0603 41.3634Z" />
      <path d="M19.0603 45.018L9.31449 45.018C8.80989 45.018 8.40079 45.4271 8.40079 45.9317C8.40079 46.4363 8.80989 46.8454 9.31449 46.8454L19.0603 46.8454C19.5649 46.8454 19.974 46.4363 19.974 45.9317C19.974 45.4271 19.565 45.018 19.0603 45.018Z" />
      <path d="M19.0603 48.6726L9.31449 48.6726C8.80989 48.6726 8.40079 49.0817 8.40079 49.5863C8.40079 50.0909 8.80989 50.5 9.31449 50.5L19.0603 50.5C19.5649 50.5 19.974 50.0909 19.974 49.5863C19.974 49.0817 19.565 48.6726 19.0603 48.6726Z" />
      <path d="M0.1875 1C0.1875 0.447715 0.635215 0 1.1875 0L27.1875 0C27.7398 0 28.1875 0.447715 28.1875 1V7C28.1875 7.55228 27.7398 8 27.1875 8L1.1875 8C0.635215 8 0.1875 7.55228 0.1875 7L0.1875 1Z" />
    </svg>
  );
};

export default DirectionArrowSVG;
